import {IEntryRepository, EntryInput, ReviewerEntryInput} from '../interface/entry';
import { PresenterFunc } from '../interface';
import { Fragment, UpdaterFunc } from '../interface/common';
import { Entry } from '../entity';

export class EntryService {
  constructor(
    private readonly entryRepository: IEntryRepository,
  ) { }

  public async approveEntries(
    ids: string[],
    presenter: PresenterFunc<Entry[] | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ): Promise<Entry[] | null> {
    presenter(null, null, true);

    let result = null;
    try {
      result = await this.entryRepository.approveEntries(ids, fragment, updater);

      presenter(null, result, false);

    } catch (err) {
      presenter(err, null, false);
    }

    return result;
  }

  public async reviewerUpdate(
      input: ReviewerEntryInput,
      presenter: PresenterFunc<Entry | null>,
      fragment?: Fragment,
      updater?: UpdaterFunc,
  ): Promise<Entry | null> {
    presenter(null, null, true);

    let result = null;
    try {
      result = await this.entryRepository.reviewerUpdate(input, fragment, updater);

      presenter(null, result, false);

    } catch (err) {
      presenter(err, null, false);
    }

    return result;
  }

  public async updateEntry(
    input: EntryInput,
    presenter: PresenterFunc<Entry | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ): Promise<Entry | null> {
    presenter(null, null, true);

    let result = null;
    try {
      result = await this.entryRepository.updateEntry(input, fragment, updater);

      presenter(null, result, false);

    } catch (err) {
      presenter(err, null, false);
    }

    return result;
  }
}
